import {
  __name
} from "./chunk-2IB33T4A.js";

// src/subjects/administracao.ts
import { z as z3 } from "zod";

// src/subjects/_actions.ts
import { z } from "zod";
var crud = z.enum([
  "create",
  "read",
  "update",
  "delete"
]);
var readOnly = z.enum([
  "read"
]);
var cannotDelete = z.enum([
  "create",
  "read",
  "update"
]);
var readUpdate = z.enum([
  "read",
  "update"
]);
var readCreate = z.enum([
  "read",
  "create"
]);
var readDelete = z.enum([
  "read",
  "delete"
]);
var cannotRead = z.enum([
  "create",
  "update",
  "delete"
]);
var cannotUpdate = z.enum([
  "create",
  "read",
  "delete"
]);

// src/utils.ts
import { schema } from "@acme/core";
import { createMongoAbility } from "@casl/ability";
import { z as z2 } from "zod";
function separateWords(str) {
  const separated = str.replace(/([a-z])([A-Z])/g, "$1 $2").split(" ");
  let result = "";
  for (const word of separated) {
    if (word === word.toUpperCase()) result += word + " ";
    else if (separated.indexOf(word) === 0) result += word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() + " ";
    else result += word.toLowerCase() + " ";
  }
  return result.trim();
}
__name(separateWords, "separateWords");
function createHref(prefix, str) {
  const regex = /([a-z])([A-Z])/g;
  return `/${prefix}/${str.replace(regex, "$1-$2")}`.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\/\//, "/").toLowerCase();
}
__name(createHref, "createHref");
function createRoutes(baseObj, prefix) {
  return z2.object(baseObj).transform((data) => {
    return Object.entries(data).reduce((acc, [key, value]) => {
      acc[value] = {
        href: createHref(prefix, key),
        label: value
      };
      return acc;
    }, {});
  });
}
__name(createRoutes, "createRoutes");
function LiteralDefault(value) {
  return z2.literal(value).default(value);
}
__name(LiteralDefault, "LiteralDefault");
function defineZodRoute(route, permissions, parser) {
  const subject = LiteralDefault(route);
  if (!parser) return {
    route: z2.tuple([
      permissions,
      subject
    ]),
    subject
  };
  if (Array.isArray(parser)) return {
    route: z2.tuple([
      permissions,
      z2.union(
        // @ts-expect-error - parser is an array
        subject,
        ...parser.map((p) => schema[p].extend({
          __typename: subject
        }))
      )
    ]),
    subject
  };
  return {
    route: z2.tuple([
      permissions,
      z2.union([
        subject,
        schema[parser].extend({
          __typename: subject
        })
      ])
    ]),
    subject
  };
}
__name(defineZodRoute, "defineZodRoute");
var createAppAbility = createMongoAbility;
function pick(object, props) {
  if (!object || typeof object !== "object") return {};
  return Object.fromEntries(props.map((key) => [
    key,
    object[key]
  ]));
}
__name(pick, "pick");

// src/subjects/administracao.ts
var { route: clientes, subject: clientesSubject } = defineZodRoute("Clientes", cannotDelete, "ClienteSchema");
var { route: parametrosFinanceiros, subject: parametrosFinanceirosSubject } = defineZodRoute("Par\xE2metrosFinanceiros", cannotDelete, "ReajusteAnualSchema");
var { route: logs, subject: logsSubject } = defineZodRoute("Logs", readOnly);
var subjects = z3.union([
  clientes,
  parametrosFinanceiros,
  logs
]);
var routes = {
  clientes: clientesSubject,
  parametrosFinanceiros: parametrosFinanceirosSubject,
  logs: logsSubject
};
var administracao = createRoutes(routes, "administracao");

// src/subjects/ajuda.ts
import { z as z4 } from "zod";
var { route: atendimentoOnline, subject: atendimentoOnlineSubject } = defineZodRoute("AtendimentoOnline", readOnly);
var { route: manual, subject: manualSubject } = defineZodRoute("Manual", readOnly);
var { route: primeirosPassos, subject: primeirosPassosSubject } = defineZodRoute("PrimeirosPassos", readOnly);
var subjects2 = z4.union([
  atendimentoOnline,
  manual,
  primeirosPassos
]);
var routes2 = {
  atendimentoOnline: atendimentoOnlineSubject,
  manual: manualSubject,
  primeirosPassos: primeirosPassosSubject
};
var ajuda = createRoutes(routes2, "ajuda");

// src/subjects/ajustes-ponto.ts
import { z as z5 } from "zod";
var { route: registros, subject: registrosSubject } = defineZodRoute("Registros", cannotRead);
var { route: abonos, subject: abonosSubject } = defineZodRoute("Abonos", cannotRead);
var { route: afastamentos, subject: afastamentosSubject } = defineZodRoute("Afastamentos", cannotRead);
var { route: compensacao, subject: compensacaoSubject } = defineZodRoute("Compensa\xE7\xE3o", cannotRead);
var { route: amamentacao, subject: amamentacaoSubject } = defineZodRoute("Amamenta\xE7\xE3o", cannotRead);
var { route: folga, subject: folgaSubject } = defineZodRoute("Folga", cannotRead);
var { route: compensacaoFeriados, subject: compensacaoFeriadosSubject } = defineZodRoute("Compensa\xE7\xE3oDeFeriados", cannotRead);
var { route: faltas, subject: faltasSubject } = defineZodRoute("FaltasJustificadasOuInjustificadas", cannotRead);
var subjects3 = z5.union([
  registros,
  abonos,
  afastamentos,
  compensacao,
  amamentacao,
  folga,
  compensacaoFeriados,
  faltas
]);
var routes3 = {
  registros: registrosSubject,
  abonos: abonosSubject,
  afastamentos: afastamentosSubject,
  compensacao: compensacaoSubject,
  amamentacao: amamentacaoSubject,
  folga: folgaSubject,
  compensacaoFeriados: compensacaoFeriadosSubject,
  faltas: faltasSubject
};
var ajustesPonto = createRoutes(routes3, "");

// src/subjects/cadastros.ts
import { z as z6 } from "zod";
var { route: centroCusto, subject: centroCustoSubject } = defineZodRoute("CentrosDeCusto", crud, "CentroCustoSchema");
var { route: empresas, subject: empresasSubject } = defineZodRoute("Empresas", crud, "EmpresaSchema");
var { route: escalas, subject: escalasSubject } = defineZodRoute("Escalas", crud, "EscalaTrabalhoSchema");
var { route: feriados, subject: feriadosSubject } = defineZodRoute("Feriados", crud, [
  "FeriadosClienteSchema",
  "FeriadosNacionaisEstaduaisSchema"
]);
var { route: funcionarios, subject: funcionarioSubject } = defineZodRoute("Funcion\xE1rios", crud, "FuncionarioSchema");
var { route: locais, subject: locaisSubject } = defineZodRoute("Locais", crud, "LocalSchema");
var { route: ocorrencias, subject: ocorrenciasSubject } = defineZodRoute("Ocorr\xEAncias", crud, "OcorrenciaSchema");
var { route: regrasCalculo, subject: regrasCalculoSubject } = defineZodRoute("RegrasDeC\xE1lculo", crud, "RegrasCalculoSchema");
var { route: rubricas, subject: rubricasSubject } = defineZodRoute("Rubricas", readUpdate, "RubricaSchema");
var { route: supervisores, subject: supervisoresSubject } = defineZodRoute("Supervisores", crud, "SupervisorSchema");
var { route: tabelaHorarios, subject: tabelaHorariosSubject } = defineZodRoute("TabelaDeHor\xE1rios", crud, "TabelaHorarioSchema");
var { route: permissoes, subject: permissoesSubject } = defineZodRoute("Permiss\xF5es", crud, "PerfilPermissaoSchema");
var subjects4 = z6.union([
  centroCusto,
  empresas,
  escalas,
  feriados,
  funcionarios,
  locais,
  ocorrencias,
  regrasCalculo,
  rubricas,
  supervisores,
  tabelaHorarios,
  permissoes
]);
var routes4 = {
  centroCusto: centroCustoSubject,
  empresas: empresasSubject,
  escalas: escalasSubject,
  feriados: feriadosSubject,
  funcionarios: funcionarioSubject,
  locais: locaisSubject,
  ocorrencias: ocorrenciasSubject,
  regrasCalculo: regrasCalculoSubject,
  rubricas: rubricasSubject,
  supervisores: supervisoresSubject,
  tabelaHorarios: tabelaHorariosSubject,
  permissoes: permissoesSubject
};
var cadastros = createRoutes(routes4, "cadastros");

// src/subjects/integracoes.ts
import { z as z7 } from "zod";
var { route: aej, subject: aejSubject } = defineZodRoute("AEJ", crud);
var { route: folhaPagamento, subject: folhaPagamentoSubject } = defineZodRoute("FolhaDePagamento", readCreate);
var { route: afd, subject: afdSubject } = defineZodRoute("AFD", readCreate);
var { route: importarFuncionarios, subject: importarFuncionariosSubject } = defineZodRoute("ImportarFuncion\xE1rios", readOnly, "FuncionarioSchema");
var { route: reps, subject: repsSubject } = defineZodRoute("Reps", crud, "RepSchema");
var { route: exportarFuncionarios, subject: exportarFuncionariosSubject } = defineZodRoute("ExportarFuncion\xE1rios", readOnly, "FuncionarioSchema");
var subjects5 = z7.union([
  aej,
  folhaPagamento,
  afd,
  importarFuncionarios,
  reps,
  exportarFuncionarios
]);
var routes5 = {
  aej: aejSubject,
  folhaPagamento: folhaPagamentoSubject,
  afd: afdSubject,
  importarFuncionarios: importarFuncionariosSubject,
  reps: repsSubject,
  exportarFuncionarios: exportarFuncionariosSubject
};
var integracoes = createRoutes(routes5, "integracoes");

// src/subjects/manutencao_ponto.ts
import { z as z8 } from "zod";
var { route: calculoPonto, subject: calculoPontoSubject } = defineZodRoute("C\xE1lculoDoPonto", crud, "CalculoSchema");
var { route: digitacao, subject: digitacaoSubject } = defineZodRoute("Digita\xE7\xE3o", readOnly);
var { route: implantacao, subject: implantacaoSubject } = defineZodRoute("Implanta\xE7\xE3oDoBancoDeHoras", crud, "SaldoHorasSchema");
var { route: sobreaviso, subject: sobreavisoSubject } = defineZodRoute("Sobreaviso", crud, "SobreavisoSchema");
var { route: trocaDiaTrabalho, subject: trocaDiaTrabalhoSubject } = defineZodRoute("TrocaDeDiaDeTrabalho", crud, "TrocaDiaTrabalhoSchema");
var { route: trocaTabelaHorario, subject: trocaTabelaHorarioSubject } = defineZodRoute("TrocaDeTabelaDeHor\xE1rio", crud, "TabelaHorarioFuncionarioSchema");
var { route: fechamentoCompetencia, subject: fechamentoCompetenciaSubject } = defineZodRoute("FechamentoDeCompet\xEAncia", readCreate, "FechamentoCompetenciaSchema");
var { route: ajustesPonto2, subject: ajustesPontoSubject } = defineZodRoute("AjustesDePonto", readOnly);
var { route: pagamentoHoras, subject: pagamentohorasSubject } = defineZodRoute("PagamentoDeHoras", readUpdate, "PagamentoHorasSchema");
var { route: ausencias, subject: ausenciasSubject } = defineZodRoute("Aus\xEAncias", readOnly);
var { route: trocaAutomaticaHorario, subject: trocaAutomaticaHorarioSubject } = defineZodRoute("TrocaAutom\xE1ticaDeHor\xE1rio", crud);
var { route: compensacaoManual, subject: compensacaoManualSubject } = defineZodRoute("Compensa\xE7\xE3oManual", crud);
var subjects6 = z8.union([
  calculoPonto,
  digitacao,
  implantacao,
  sobreaviso,
  trocaDiaTrabalho,
  trocaTabelaHorario,
  fechamentoCompetencia,
  ajustesPonto2,
  pagamentoHoras,
  ausencias,
  trocaAutomaticaHorario,
  compensacaoManual
]);
var routes6 = {
  calculoPonto: calculoPontoSubject,
  digitacao: digitacaoSubject,
  bancoHoras: implantacaoSubject,
  sobreaviso: sobreavisoSubject,
  trocaDiaTrabalho: trocaDiaTrabalhoSubject,
  trocaTabelaHorario: trocaTabelaHorarioSubject,
  fechamentoCompetencia: fechamentoCompetenciaSubject,
  ajustesPonto: ajustesPontoSubject,
  pagamentoHoras: pagamentohorasSubject,
  ausencias: ausenciasSubject,
  trocaAutomaticaHorario: trocaAutomaticaHorarioSubject,
  compensacaoManual: compensacaoManualSubject
};
var manutencaoPonto = createRoutes(routes6, "manutencao-ponto");

// src/subjects/notListed.ts
import { z as z9 } from "zod";
var { route: selecionarFuncionario, subject: selecionarFuncionarioSubject } = defineZodRoute("SelecionarFuncion\xE1rio", readOnly);
var { route: planos, subject: planosSubject } = defineZodRoute("Planos", readOnly);
var { route: perfil, subject: perfilSubject } = defineZodRoute("Perfil", readUpdate);
var { route: alteracoes, subject: alteracoesSubject } = defineZodRoute("Altera\xE7\xF5es", readOnly);
var { route: historicoLogin, subject: historicoLoginSubject } = defineZodRoute("Hist\xF3ricoDeLogin", readDelete);
var { route: checkout, subject: checkoutSubject } = defineZodRoute("Checkout", readOnly);
var { route: dashboard, subject: dashboardSubject } = defineZodRoute("Dashboard", readOnly);
var { route: atestadoTecnico, subject: atestadoTecnicoSubject } = defineZodRoute("AtestadoDeCapacidadeT\xE9cnica", readOnly);
var { route: ajustesImpressos, subject: AssinaturaEletronicaDeAjustesSubject } = defineZodRoute("AssinaturaEletr\xF4nicaDeAjustes", crud);
var subjects7 = z9.union([
  selecionarFuncionario,
  planos,
  perfil,
  alteracoes,
  historicoLogin,
  checkout,
  dashboard,
  atestadoTecnico,
  ajustesImpressos
]);
var routes7 = {
  selecionarFuncionario: selecionarFuncionarioSubject,
  planos: planosSubject,
  perfil: perfilSubject,
  alteracoes: alteracoesSubject,
  historicoLogin: historicoLoginSubject,
  checkout: checkoutSubject,
  dashboard: dashboardSubject,
  atestadoTecnico: atestadoTecnicoSubject,
  ajustesImpressos: AssinaturaEletronicaDeAjustesSubject
};
var notListed = createRoutes(routes7, "");

// src/subjects/relatorios.ts
import { z as z10 } from "zod";
var { route: adicionalNoturno, subject: adicionalNoturnoSubject } = defineZodRoute("AdicionalNoturno", readOnly);
var { route: saldoHoras, subject: saldoHorasSubject } = defineZodRoute("SaldoDeHoras", readOnly, "SaldoHorasSchema");
var { route: espelhoPonto, subject: espelhoPontoSubject } = defineZodRoute("EspelhoDoPonto", readUpdate, "EspelhoPontoSchema");
var { route: inconsistencias, subject: inconsistenciasSubject } = defineZodRoute("Inconsist\xEAncias", readOnly);
var { route: valeAlimentacao, subject: valeAlimentacaoSubject } = defineZodRoute("ValeAlimenta\xE7\xE3o", readUpdate, "ValeAlimentacaoSchema");
var { route: absenteismo, subject: absenteismoSubject } = defineZodRoute("Absente\xEDsmo", readOnly);
var { route: registrosForaCerca, subject: registrosForaCercaSubject } = defineZodRoute("RegistrosForaDaCerca", readOnly, "RegistroSchema");
var { route: ajustes, subject: ajustesSubject } = defineZodRoute("Ajustes", cannotUpdate);
var { route: aceiteEspelho, subject: aceiteEspelhoSubject } = defineZodRoute("AceiteDoEspelhoDoPonto", cannotDelete);
var { route: registrosExcluidos, subject: registrosExcluidosSubject } = defineZodRoute("RegistrosExclu\xEDdos", readOnly, "RegistroSchema");
var { route: comprovantePonto, subject: comprovantePontoSubject } = defineZodRoute("ComprovanteDePonto", readOnly);
var { route: descontoDSR, subject: descontoDSRSubject } = defineZodRoute("DescontoDeDSR", readOnly, "DescontoDsrSchema");
var { route: horasTrabalhadas, subject: horasTrabalhadasSubject } = defineZodRoute("HorasTrabalhadas", readOnly);
var { route: horasSuprimidas, subject: horasSuprimidasSubject } = defineZodRoute("HorasSuprimidas", readOnly);
var { route: pontoDiario, subject: pontoDiarioSubject } = defineZodRoute("PontoDi\xE1rio", readOnly);
var subjects8 = z10.union([
  adicionalNoturno,
  saldoHoras,
  espelhoPonto,
  inconsistencias,
  valeAlimentacao,
  absenteismo,
  registrosForaCerca,
  ajustes,
  aceiteEspelho,
  registrosExcluidos,
  comprovantePonto,
  descontoDSR,
  horasTrabalhadas,
  horasSuprimidas,
  pontoDiario
]);
var routes8 = {
  adicionalNoturno: adicionalNoturnoSubject,
  saldoHoras: saldoHorasSubject,
  espelhoPonto: espelhoPontoSubject,
  inconsistencias: inconsistenciasSubject,
  valeAlimentacao: valeAlimentacaoSubject,
  absenteismo: absenteismoSubject,
  registrosForaCerca: registrosForaCercaSubject,
  ajustes: ajustesSubject,
  aceiteEspelho: aceiteEspelhoSubject,
  registrosExcluidos: registrosExcluidosSubject,
  comprovantePonto: comprovantePontoSubject,
  descontoDSR: descontoDSRSubject,
  horasTrabalhadas: horasTrabalhadasSubject,
  horasSuprimidas: horasSuprimidasSubject,
  pontoDiario: pontoDiarioSubject
};
var relatorios = createRoutes(routes8, "relatorios");

// src/modules.ts
var MODULOS = {
  Administra\u00E7\u00E3o: administracao.parse({}),
  Cadastros: cadastros.parse({}),
  Manuten\u00E7\u00E3oDoPonto: manutencaoPonto.parse({}),
  Integra\u00E7\u00F5es: integracoes.parse({}),
  Relat\u00F3rios: relatorios.parse({}),
  Ajuda: ajuda.parse({})
};
var naoListadas = notListed.parse({});
var MODULOS_EXTRAS = {
  AceiteDoEspelhoDoPonto: MODULOS.Relat\u00F3rios.AceiteDoEspelhoDoPonto,
  AssinaturaEletr\u00F4nicaDeAjustes: naoListadas.AssinaturaEletr\u00F4nicaDeAjustes
};
var ajustesPonto3 = ajustesPonto.parse({});
function groupAbilitiesByModule(appAbilities) {
  return appAbilities.reduce((acc, { subject, abilities }) => {
    const module = Object.entries({
      ...MODULOS,
      Outros: pick(naoListadas, [
        "Altera\xE7\xF5es"
      ]),
      "Ajustes de ponto": ajustesPonto3
    }).find(([_, subjects9]) => Object.keys(subjects9).includes(subject));
    if (!module) return acc;
    const [moduleName] = module;
    if (!acc[moduleName]) acc[moduleName] = [];
    acc[moduleName].push({
      subject,
      abilities
    });
    return acc;
  }, {});
}
__name(groupAbilitiesByModule, "groupAbilitiesByModule");
var modules_default = MODULOS;

export {
  separateWords,
  createAppAbility,
  naoListadas,
  MODULOS_EXTRAS,
  ajustesPonto3 as ajustesPonto,
  groupAbilitiesByModule,
  modules_default
};
//# sourceMappingURL=chunk-KEQUYR6M.js.map